module.exports = __webpack_public_path__ + "img/yijia1.fe589015.jpg";